import lodash from "lodash";
import {
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect
} from "../../../../components/table/c-table.logic";
import store from "../../../../store";
import { createLoading } from "../../../../utils/loading";
import i18n from "../../../../i18n";
import { createManageDelete, createPage, createRowActionDelete, createRowActionEdit } from "../../../../utils/page";
import { conditionFormChecker, initUseForm, onClickDeleteAllClient, putField } from "../../../../utils/form";
import { createButtonCreate } from "../../../../utils/button";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { greaterThan, lessThanOrEqualTo, required, requiredWhen, validateError } from "../../../../utils/validate";
import {
    createFieldInput,
    createFieldInputNumber,
    createFieldSelect
} from "../../../../components/input/template-builder/template-builder.logic";
import { modalStyleForm } from "../../../../utils/constant";
import { addModal, removeModal } from "../../../../app.logic";
import { createConditionForm } from "./fishing-tool.condition";
import { filter } from "../../../../utils/search";
import { Button, Form, Modal } from "ant-design-vue";
import { CIcon, openModalExampleImage } from "../vessel/attachment-vessel/attachment-full-vessel.logic";
// import { openModalList as openModalFishingTool } from "../../setting/data-mgt/fishing-tool/fishing-tool.logic";
// import { onIFrameClickSelectAll } from "../../../../utils/iframe";
// import { has } from "../../../../utils/menu-context";

export const { isLoading, setIsLoading } = createLoading()
const FishingToolForm = defineAsyncComponent(() => import('./FishingToolForm'))

export const callToolUnit = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "TOOL_UNIT", value: searchQuery });

export const callWidthUnit = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "WIDTH_UNIT", value: searchQuery });

export const callFishingTool = ({ searchQuery, refParentId, refParentOperator = "=", where = [], checkLimit = false }) => {
    if (searchQuery) {
        where.push({ name: "nameTh", type: "String", operator: "like", value: searchQuery })
    }
    if (checkLimit) {
        where.push({ name: "isCountLimitRequest", type: "Boolean", operator: "=", value: false })
    }
    return store
        .dispatch("resource/v1/master/fishingTool/search", {
            criteria: {
                select: ["**"],
                page: 0,
                size: 100000,
                where: [
                    ...where,
                    { name: "isActive", type: "Boolean", operator: "=", value: true },
                    { name: "refParent.id", type: "UUID", operator: refParentOperator, value: refParentId },
                ],
                sort: [{ name: "nameTh", type: "ASC" }],
                children: []
            }
        })
        .then(page => page.data);
};

export const createColumns = () => {
    const columns = [
        createColumnSelect({
            title: () => i18n.global.t("model.fishingToolRequest.refFishingToolType"),
            dataIndex: "refFishingToolType.id",
            customRender: ({ record }) => <div>{record.refFishingToolType?.nameTh}</div>,
            inputProp: () => ({ list: (searchQuery) => callFishingTool({ searchQuery, refParentOperator: "=", refParentId: null }) })
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.fishingToolRequest.refFishingTool"),
            dataIndex: "refFishingTool.id",
            customRender: ({ record }) => <div>{record.refFishingTool?.nameTh}</div>,
            inputProp: () => ({ list: (searchQuery) => callFishingTool({ searchQuery, refParentOperator: "!=", refParentId: null }) })
        }),
        createColumnInputNumber({ title: () => i18n.global.t("model.fishingToolRequest.qty"), dataIndex: "qty", comma: true, align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.fishingToolRequest.refUnitType"),
            dataIndex: "refUnitType.id",
            customRender: ({ record }) => <div>{record.refUnitType?.value}</div>,
            inputProp: () => ({ list: callToolUnit })
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.fishingToolRequest.width"),
            dataIndex: "width",
            align: "right",
            allowPrecision: true,
            maxPrecision: 2,
        }),
        createColumnInput({
            title: () => i18n.global.t("model.fishingToolRequest.duringFishing"),
            dataIndexValue: ({ record }) => {
                let duringFishing = record.monthStartFishing + " - " + record.monthEndFishing
                return duringFishing
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
    ]
    return columns
}

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, visible } = props
    const { useForm } = data
    const { modelRef } = useForm
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef
    const userInfo = store.state.resource.auth.info?.user;
    data.columns = createColumns({ props })
    data.page = createPage({ data: items })
    data.tableOptions = { search: { activeKey: null } }
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => ["draft", "waitModify"].includes(modelRef.refStatus?.key) && userInfo.username == modelRef.createBy && !viewOnly,
            onClick: ({ rowSelection }) => onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey })
        }),
    ]

    data.manageExtras = []
    data.rowActions = [
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) =>
                openModalForm({
                    props: {
                        menuContext,
                        viewOnly,
                        setAppPageHeader: false,
                        form: record,
                        itemsList: items
                    }}),
            visible: () => !viewOnly
        }),
        createRowActionDelete({
            menuContext,
            onClick: ({ record }) => {
                Modal.confirm({
                    title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: i18n.global.t("button.delete") }),
                    autoFocusButton: "cancel",
                    okType: "danger",
                    onOk: () => {
                        onClickDeleteAllClient({
                            rowSelection: { selectedRows: [record] },
                            items: modelRef.fishingToolRequests
                        })
                    }
                });
            },
            visible: () => !viewOnly
        })

    ]
    if (!viewOnly) {
        if (visible === true) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () => openModalForm({ props, items }),
                        options: { 
                            text: i18n.global.t('button.create'),
                            disabled: viewOnly || conditionFishingTool({ modelRef })
                        }
                    }),
                }),
                visible: () => !viewOnly,
            })
        }
    }
}

export const initForm = ({ props, data, refs }) => {
    data.form = createForm();
    data.rules = createRules({ props, data, refs });
    data.useForm =  createUseForm(data.form, data.rules);
    data.fields =  createFields({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    loadForm({ props, data, refs })
}

export const createForm = () => {
    return {
        refLicenseRequest: null,
        refFishingTool: null,
        refFishingToolType: null,
        qty: null,
        refUnitType: null,
        width: null,
        refWidthType: null,
        monthStartFishing: null,
        monthEndFishing: null,
        fishingToolName: null
    }
}

export const createRules = ({ props, data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    return {
        refFishingToolType: [required],
        refFishingTool: [required],
        qty: [
            requiredWhen({ when: () => model.refFishingTool?.isRequireInputQty }),
            {
                ...requiredWhen({
                    when: () => model.refFishingTool?.isRequireInputQty,
                    requiredValidator: ({ rule, value }) => {
                        return greaterThan(0).validator(rule, value);
                    }
                }),
                trigger: "blur"
            },
            {
                ...requiredWhen({
                    when: () => model.refFishingTool?.isMaximumQty,
                    requiredValidator: ({ rule, value }) => {
                        return lessThanOrEqualTo(model.refFishingTool?.maximumQty).validator(rule, value);
                    }
                }),
                trigger: "blur"
            }
        ],
        firstSubQty: [
            requiredWhen({ when: () => model.refFishingTool?.isRequireInputQty && model.refFishingTool.isSubQty }),
            {
                ...requiredWhen({
                    when: () => model.refFishingTool?.isRequireInputQty && model.refFishingTool.isSubQty,
                    requiredValidator: ({ rule, value }) => {
                        return greaterThan(0).validator(rule, value);
                    }
                }),
                trigger: "blur"
            },
            {
                ...requiredWhen({
                    when: () => model.refFishingTool?.isSubQty && model.refFishingTool?.firstSubMaxQty != null,
                    requiredValidator: ({ rule, value }) => {
                        return lessThanOrEqualTo(model.refFishingTool?.firstSubMaxQty).validator(rule, value);
                    }
                }),
                trigger: "blur"
            }
        ],
        fishingToolName: [
            requiredWhen({ when: () => model.refFishingTool?.isSelfNamingToolName }),
        ],
        secondSubQty: [
            requiredWhen({ when: () => model.refFishingTool?.isRequireInputQty && model.refFishingTool.isSubQty }),
            {
                ...requiredWhen({
                    when: () => model.refFishingTool?.isRequireInputQty && model.refFishingTool.isSubQty,
                    requiredValidator: ({ rule, value }) => {
                        return greaterThan(0).validator(rule, value);
                    }
                }),
                trigger: "blur"
            },
            {
                ...requiredWhen({
                    when: () => model.refFishingTool?.isSubQty && model.refFishingTool?.secondSubMaxQty != null,
                    requiredValidator: ({ rule, value }) => {
                        return lessThanOrEqualTo(model.refFishingTool?.secondSubMaxQty).validator(rule, value);
                    }
                }),
                trigger: "blur"
            }
        ],
        refUnitType: [required],
        width: [
            requiredWhen({ when: () => model.refFishingTool?.isRequireInputWidth }),
            {
                ...requiredWhen({
                    when: () => model.refFishingTool?.isRequireInputWidth,
                    requiredValidator: ({ rule, value }) => {
                        return greaterThan(0).validator(rule, value);
                    }
                }),
                trigger: "blur"
            },
            {
                ...requiredWhen({
                    when: () => model.refFishingTool?.isMaximumWidth && props?.maximumWidth,
                    requiredValidator: ({ rule, value }) => {
                        return lessThanOrEqualTo(props.maximumWidth).validator(rule, value);
                    }
                }),
                trigger: "blur"
            }
        ],
        monthStartFishing: [required],
        monthEndFishing: [required]
    }
}

export const createFields = ({ props, data, key }) => {
    const { viewOnly, usedFishingTools, hiddenPreviewButton, maximumWidth } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    const listMonth = generateListMonth();

    let countLimit = 3;
    usedFishingTools?.forEach((item) => {
        if (item.refFishingTool.isCountLimitRequest) countLimit--
    })
    let checkLimit = countLimit <= 0 ? true : false;
    let where = []
    if (usedFishingTools?.map(d => d.refFishingTool?.id).length) {
        where.push({ name: "id", type: "UUID", isNot: true, operator: "in", value: usedFishingTools?.map(d => d.refFishingTool?.id) })
    }
    return putField({
        data, fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refFishingToolType`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.refFishingToolType")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refFishingToolType,
                            "onUpdate:value": value => {
                                model.refFishingToolType = value;
                                if (model.refFishingTool && model.refFishingTool.refParent?.id !== model.refFishingToolType?.id) {
                                    model.refFishingTool = null;
                                    model.qty = null
                                    model.width = null
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callFishingTool({ searchQuery, refParentOperator: "=", refParentId: null }),
                            optLabel: "nameTh"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refFishingTool`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.refFishingTool")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refFishingTool,
                            "onUpdate:value": value => {
                                if (!value) {
                                    model.qty = null
                                    model.width = null
                                }
                                model.refFishingTool = value
                                model.refUnitType = value.refFishingToolUnit
                                model.refWidthType = value.refWidthUnit
                                model.firstSubQty = null;
                                model.secondSubQty = null;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callFishingTool({ searchQuery, refParentOperator: "=", refParentId: model.refFishingToolType?.id, checkLimit, where }),
                            optLabel: "nameTh",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}fishingToolName`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.fishingToolRequest.fishingToolName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.fishingToolName,
                            "onUpdate:value": (value) => (model.fishingToolName = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}firstSubQty`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.firstSubQty")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.firstSubQty,
                            "onUpdate:value": value => {
                                model.firstSubQty = value;
                                // if (model.refFishingTool?.maximumQty > 0 && value > model.refFishingTool?.maximumQty) {
                                //     model.firstSubQty = lodash.cloneDeep(model.refFishingTool?.maximumQty)
                                //     model.secondSubQty = 0
                                //     model.qtyTemp = model.secondSubQty
                                // } else {
                                //     model.firstSubQty = parseFloat(value) || 0;
                                // }
                                setQtyBySubQty({ model });
                            },
                            disabled: viewOnly,
                            comma: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}secondSubQty`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.secondSubQty")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.secondSubQty,
                            "onUpdate:value": value => {
                                // if (model.refFishingTool?.maximumQty > 0 && parseFloat(model.firstSubQty || 0) + parseFloat(value || 0) >= model.refFishingTool?.maximumQty) {
                                //     model.secondSubQty = model.qtyTemp
                                // } else {
                                //     model.secondSubQty = parseFloat(value) || 0;
                                //     model.qtyTemp = model.secondSubQty
                                // }
                                model.secondSubQty = value
                                setQtyBySubQty({ model });
                            },
                            disabled: viewOnly,
                            comma: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}qty`,
                colProp: () => ({ xs: 24, md: 18, style: { paddingLeft: "2px !important" } }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.qty")}  ${ !model.refFishingTool?.maximumQty ? "" : i18n.global.t("model.fishingToolRequest.labels.maximumQty", { max: model.refFishingTool?.maximumQty })}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.qty,
                            "onUpdate:value": value => {
                                // if (model.refFishingTool?.maximumQty > 0 && value > model.refFishingTool?.maximumQty) {
                                //     model.qty = lodash.cloneDeep(model.refFishingTool?.maximumQty)
                                // } else {
                                    model.qty = value;
                                //}
                            },
                            disabled: viewOnly,
                            comma: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refUnitType`,
                colProp: () => ({ xs: 24, md: 6 }),
                formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refUnitType,
                            "onUpdate:value": value => (model.refUnitType = value),
                            disabled: true,
                            list: callToolUnit,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}width`,
                colProp: () => ({ xs: 24, md: 18, style: { paddingLeft: "2px !important" } }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
                label: () =>
                    `${i18n.global.t("model.fishingToolRequest.width")}  ${
                        !model.refFishingTool?.maximumWidth
                            ? ""
                            : i18n.global.t("model.fishingToolRequest.labels.maximumWidth", { max: maximumWidth ? maximumWidth: model.refFishingTool?.maximumWidth })
                        }`,                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.width,
                            "onUpdate:value": value => {
                                // if (model.refFishingTool?.maximumWidth > 0 && value > model.refFishingTool?.maximumWidth) {
                                //     model.width = lodash.cloneDeep(model.refFishingTool?.maximumWidth)
                                // } else {
                                    model.width = value;
                                //}
                            },
                            disabled: viewOnly,
                            comma: true,
                            allowPrecision: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refWidthType`,
                colProp: () => ({ xs: 24, md: 6 }),
                formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refWidthType,
                            "onUpdate:value": value => (model.refWidthType = value),
                            disabled: true,
                            list: callWidthUnit,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}monthStartFishing`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.monthStartFishing")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: listMonth.find(month => month.nameTh === model.monthStartFishing),
                            "onUpdate:value": value => {
                                model.monthStartFishing = value.nameTh
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                filter({
                                    list: listMonth,
                                    where: [
                                        { name: 'nameTh', operator: 'like', value: searchQuery },
                                        { logic: 'OR', name: 'nameEn', operator: 'like', value: searchQuery },
                                    ],
                                    sort: [{ name: 'seq', type: 'ASC' }] }),
                            optKey: "nameTh",
                            optLabel: "nameTh"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}monthEndFishing`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.monthEndFishing")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: listMonth.find(month => month.nameTh === model.monthEndFishing),
                            "onUpdate:value": value => {
                                model.monthEndFishing = value.nameTh
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                filter({
                                    list: listMonth,
                                    where: [
                                        { name: 'nameTh', operator: 'like', value: searchQuery },
                                        { logic: 'OR', name: 'nameEn', operator: 'like', value: searchQuery },
                                    ],
                                    sort: [{ name: 'seq', type: 'ASC' }] }),
                            optKey: "nameTh",
                            optLabel: "nameTh"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}exampleImage`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.exampleImage")}`,
                formItemRender: ({ field }) =>  {
                    const label = field?.label?.();
                    const formItemProp = field?.formItemProp?.({ field });
                    const buttonPreview = <Button size='medium' onClick={() => { openModalExampleImage({ file: { url: model.refFishingTool?.path } }) }}>
                        <CIcon file="eye.svg"></CIcon>
                        <span>{i18n.global.t("views.request.licenseRequest.exampleImage")}</span>
                    </Button>
                    return hiddenPreviewButton ? <Form.Item label={label} {...formItemProp}></Form.Item> : <Form.Item label={label} {...formItemProp}>{buttonPreview}</Form.Item>
                }
            },
        ]
    })
}

export const setQtyBySubQty = ({ model }) => {
    if (model.firstSubQty || model.secondSubQty) {
        model.qty = parseFloat(model.firstSubQty || 0) + parseFloat(model.secondSubQty || 0)
    } else {
        model.qty = null
    }

}

export const loadForm = ({ props, data }) => {
    setIsLoading(true)
    const { form } = props
    const { useForm } = data
    const { modelRef } = useForm
    let promise = null
    if (form) {
        promise = Promise.resolve({ data: [form] })
    } else {
        promise = Promise.resolve({ data: [modelRef] })
    }
    return promise
        .then(page => initUseForm({ data, page }))
        .finally(() => setIsLoading(false))
}

export const openModalForm = ({ props, items, callback }) => {
    const refs = reactive({ form: null })
    let usedFishingTools = !items ?
        props.itemsList?.filter(d => !d.isDelete && (d.id != props.form?.id || d._id != props.form?._id))
        : items?.filter(d => !d.isDelete);
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            width: '50%',
            okButtonProps: { disabled: props.viewOnly },
            header: i18n.global.t('model.button.create'),
            onOk: () => {
                refs.form.callOnClickModalOk()
                    .then((record) => {
                        callback?.();
                        if (items) {
                            items.push(record)
                        } else {
                            lodash.merge(props.form, record)
                        }
                        options.bind.onCancel()
                    })
            },
            onCancel: () => {
                callback?.();
                removeModal({ options })
            }
        }),
        render: () =>
            <FishingToolForm
                ref={
                    (e) => {
                        if (e) refs.form = e
                    }
                }
                {...props}
                usedFishingTools={usedFishingTools}
            ></FishingToolForm>
    })
    return options
}

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error })
            throw error
        });
}

export const conditionFishingTool = ({ modelRef }) => {
    return ![undefined, "draft", "waitModify"].includes(modelRef.refStatus?.key);
};

export const generateListMonth = () => {
    const listMonth = [
        {
            seq: 1,
            nameTh: 'มกราคม',
            nameEn: 'January',
        },
        {
            seq: 2,
            nameTh: 'กุมภาพันธ์',
            nameEn: 'February',
        },
        {
            seq: 3,
            nameTh: 'มีนาคม',
            nameEn: 'March',
        },
        {
            seq: 4,
            nameTh: 'เมษายน',
            nameEn: 'April',
        },
        {
            seq: 5,
            nameTh: 'พฤษภาคม',
            nameEn: 'May',
        },
        {
            seq: 6,
            nameTh: 'มิถุนายน',
            nameEn: 'June',
        },
        {
            seq: 7,
            nameTh: 'กรกฎาคม',
            nameEn: 'July',
        },
        {
            seq: 8,
            nameTh: 'สิงหาคม',
            nameEn: 'August ',
        },
        {
            seq: 9,
            nameTh: 'กันยายน',
            nameEn: 'September',
        },
        {
            seq: 10,
            nameTh: 'ตุลาคม',
            nameEn: 'October',
        },
        {
            seq: 11,
            nameTh: 'พฤศจิกายน',
            nameEn: 'November',
        },
        {
            seq: 12,
            nameTh: 'ธันวาคม',
            nameEn: 'December',
        },
    ]
    return listMonth
}